import { useEffect, useState } from 'react'
import { useMedplum } from '@medplum/react'
import { logError } from '@/utils/errorUtils'

/**
 * Something an `<img>` can show for a stored `Binary/<id>` reference, which only the
 * viewer's Medplum client can resolve: the Binary is downloaded and handed back as an
 * object URL, revoked when the reference changes or the caller unmounts. `null` while there
 * is no reference or the download is still in flight.
 */
export function useBinaryObjectUrl(reference: string | null | undefined): string | null {
  const medplum = useMedplum()
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    setObjectUrl(null)
    if (!reference) return
    let url: string | null = null
    let cancelled = false
    medplum
      .download(reference)
      .then((blob) => {
        if (cancelled) return
        url = URL.createObjectURL(blob)
        setObjectUrl(url)
      })
      .catch((err) => logError('profile', 'Failed to load the photo', err))
    return () => {
      cancelled = true
      if (url) URL.revokeObjectURL(url)
    }
  }, [medplum, reference])

  return objectUrl
}
